/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as SubmissionsRouteImport } from './routes/submissions'
import { Route as ShareRouteImport } from './routes/share'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as DesignShowcaseRouteImport } from './routes/design-showcase'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SyncIndexRouteImport } from './routes/sync/index'
import { Route as SyncActiveRouteImport } from './routes/sync/active'
import { Route as SessionsNewRouteImport } from './routes/sessions/new'
import { Route as SessionsSessionIdRouteImport } from './routes/sessions/$sessionId'
import { Route as OnboardingPermissionsRouteImport } from './routes/onboarding/permissions'
import { Route as SyncConflictsTaskIdRouteImport } from './routes/sync/conflicts/$taskId'
import { Route as SessionsSessionIdShareRouteImport } from './routes/sessions/$sessionId/share'
import { Route as SessionsSessionIdReviewRouteImport } from './routes/sessions/$sessionId/review'
import { Route as SessionsSessionIdModesRouteImport } from './routes/sessions/$sessionId/modes'
import { Route as SessionsSessionIdFormRouteImport } from './routes/sessions/$sessionId/form'
import { Route as SessionsSessionIdReviewSuccessRouteImport } from './routes/sessions/$sessionId/review/success'
import { Route as SessionsSessionIdReviewSignRouteImport } from './routes/sessions/$sessionId/review/sign'
import { Route as SessionsSessionIdFormFieldIdRouteImport } from './routes/sessions/$sessionId/form/$fieldId'
import { Route as SessionsSessionIdCapturesCaptureIdRouteImport } from './routes/sessions/$sessionId/captures/$captureId'
import { Route as SessionsSessionIdCaptureVoiceRouteImport } from './routes/sessions/$sessionId/capture/voice'
import { Route as SessionsSessionIdCaptureVideoRouteImport } from './routes/sessions/$sessionId/capture/video'
import { Route as SessionsSessionIdCapturePhotoRouteImport } from './routes/sessions/$sessionId/capture/photo'
import { Route as SessionsSessionIdCaptureNoteRouteImport } from './routes/sessions/$sessionId/capture/note'
import { Route as SessionsSessionIdCaptureGpsRouteImport } from './routes/sessions/$sessionId/capture/gps'
import { Route as SessionsSessionIdCaptureBarcodeRouteImport } from './routes/sessions/$sessionId/capture/barcode'
import { Route as SessionsSessionIdFormFieldIdSuggestionsRouteImport } from './routes/sessions/$sessionId/form/$fieldId/suggestions'
import { Route as SessionsSessionIdCaptureVoiceReviewCaptureIdRouteImport } from './routes/sessions/$sessionId/capture/voice/review/$captureId'
import { Route as SessionsSessionIdCapturePhotoReviewCaptureIdRouteImport } from './routes/sessions/$sessionId/capture/photo/review/$captureId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionsRoute = SubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareRoute = ShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignShowcaseRoute = DesignShowcaseRouteImport.update({
  id: '/design-showcase',
  path: '/design-showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncIndexRoute = SyncIndexRouteImport.update({
  id: '/sync/',
  path: '/sync/',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncActiveRoute = SyncActiveRouteImport.update({
  id: '/sync/active',
  path: '/sync/active',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsNewRoute = SessionsNewRouteImport.update({
  id: '/sessions/new',
  path: '/sessions/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSessionIdRoute = SessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPermissionsRoute = OnboardingPermissionsRouteImport.update({
  id: '/onboarding/permissions',
  path: '/onboarding/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncConflictsTaskIdRoute = SyncConflictsTaskIdRouteImport.update({
  id: '/sync/conflicts/$taskId',
  path: '/sync/conflicts/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSessionIdShareRoute = SessionsSessionIdShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => SessionsSessionIdRoute,
} as any)
const SessionsSessionIdReviewRoute = SessionsSessionIdReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => SessionsSessionIdRoute,
} as any)
const SessionsSessionIdModesRoute = SessionsSessionIdModesRouteImport.update({
  id: '/modes',
  path: '/modes',
  getParentRoute: () => SessionsSessionIdRoute,
} as any)
const SessionsSessionIdFormRoute = SessionsSessionIdFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => SessionsSessionIdRoute,
} as any)
const SessionsSessionIdReviewSuccessRoute =
  SessionsSessionIdReviewSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => SessionsSessionIdReviewRoute,
  } as any)
const SessionsSessionIdReviewSignRoute =
  SessionsSessionIdReviewSignRouteImport.update({
    id: '/sign',
    path: '/sign',
    getParentRoute: () => SessionsSessionIdReviewRoute,
  } as any)
const SessionsSessionIdFormFieldIdRoute =
  SessionsSessionIdFormFieldIdRouteImport.update({
    id: '/$fieldId',
    path: '/$fieldId',
    getParentRoute: () => SessionsSessionIdFormRoute,
  } as any)
const SessionsSessionIdCapturesCaptureIdRoute =
  SessionsSessionIdCapturesCaptureIdRouteImport.update({
    id: '/captures/$captureId',
    path: '/captures/$captureId',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCaptureVoiceRoute =
  SessionsSessionIdCaptureVoiceRouteImport.update({
    id: '/capture/voice',
    path: '/capture/voice',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCaptureVideoRoute =
  SessionsSessionIdCaptureVideoRouteImport.update({
    id: '/capture/video',
    path: '/capture/video',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCapturePhotoRoute =
  SessionsSessionIdCapturePhotoRouteImport.update({
    id: '/capture/photo',
    path: '/capture/photo',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCaptureNoteRoute =
  SessionsSessionIdCaptureNoteRouteImport.update({
    id: '/capture/note',
    path: '/capture/note',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCaptureGpsRoute =
  SessionsSessionIdCaptureGpsRouteImport.update({
    id: '/capture/gps',
    path: '/capture/gps',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdCaptureBarcodeRoute =
  SessionsSessionIdCaptureBarcodeRouteImport.update({
    id: '/capture/barcode',
    path: '/capture/barcode',
    getParentRoute: () => SessionsSessionIdRoute,
  } as any)
const SessionsSessionIdFormFieldIdSuggestionsRoute =
  SessionsSessionIdFormFieldIdSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => SessionsSessionIdFormFieldIdRoute,
  } as any)
const SessionsSessionIdCaptureVoiceReviewCaptureIdRoute =
  SessionsSessionIdCaptureVoiceReviewCaptureIdRouteImport.update({
    id: '/review/$captureId',
    path: '/review/$captureId',
    getParentRoute: () => SessionsSessionIdCaptureVoiceRoute,
  } as any)
const SessionsSessionIdCapturePhotoReviewCaptureIdRoute =
  SessionsSessionIdCapturePhotoReviewCaptureIdRouteImport.update({
    id: '/review/$captureId',
    path: '/review/$captureId',
    getParentRoute: () => SessionsSessionIdCapturePhotoRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/design-showcase': typeof DesignShowcaseRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/projects': typeof ProjectsRoute
  '/share': typeof ShareRoute
  '/submissions': typeof SubmissionsRoute
  '/templates': typeof TemplatesRoute
  '/welcome': typeof WelcomeRoute
  '/onboarding/permissions': typeof OnboardingPermissionsRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRouteWithChildren
  '/sessions/new': typeof SessionsNewRoute
  '/sync/active': typeof SyncActiveRoute
  '/sync/': typeof SyncIndexRoute
  '/sessions/$sessionId/form': typeof SessionsSessionIdFormRouteWithChildren
  '/sessions/$sessionId/modes': typeof SessionsSessionIdModesRoute
  '/sessions/$sessionId/review': typeof SessionsSessionIdReviewRouteWithChildren
  '/sessions/$sessionId/share': typeof SessionsSessionIdShareRoute
  '/sync/conflicts/$taskId': typeof SyncConflictsTaskIdRoute
  '/sessions/$sessionId/capture/barcode': typeof SessionsSessionIdCaptureBarcodeRoute
  '/sessions/$sessionId/capture/gps': typeof SessionsSessionIdCaptureGpsRoute
  '/sessions/$sessionId/capture/note': typeof SessionsSessionIdCaptureNoteRoute
  '/sessions/$sessionId/capture/photo': typeof SessionsSessionIdCapturePhotoRouteWithChildren
  '/sessions/$sessionId/capture/video': typeof SessionsSessionIdCaptureVideoRoute
  '/sessions/$sessionId/capture/voice': typeof SessionsSessionIdCaptureVoiceRouteWithChildren
  '/sessions/$sessionId/captures/$captureId': typeof SessionsSessionIdCapturesCaptureIdRoute
  '/sessions/$sessionId/form/$fieldId': typeof SessionsSessionIdFormFieldIdRouteWithChildren
  '/sessions/$sessionId/review/sign': typeof SessionsSessionIdReviewSignRoute
  '/sessions/$sessionId/review/success': typeof SessionsSessionIdReviewSuccessRoute
  '/sessions/$sessionId/form/$fieldId/suggestions': typeof SessionsSessionIdFormFieldIdSuggestionsRoute
  '/sessions/$sessionId/capture/photo/review/$captureId': typeof SessionsSessionIdCapturePhotoReviewCaptureIdRoute
  '/sessions/$sessionId/capture/voice/review/$captureId': typeof SessionsSessionIdCaptureVoiceReviewCaptureIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/design-showcase': typeof DesignShowcaseRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/projects': typeof ProjectsRoute
  '/share': typeof ShareRoute
  '/submissions': typeof SubmissionsRoute
  '/templates': typeof TemplatesRoute
  '/welcome': typeof WelcomeRoute
  '/onboarding/permissions': typeof OnboardingPermissionsRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRouteWithChildren
  '/sessions/new': typeof SessionsNewRoute
  '/sync/active': typeof SyncActiveRoute
  '/sync': typeof SyncIndexRoute
  '/sessions/$sessionId/form': typeof SessionsSessionIdFormRouteWithChildren
  '/sessions/$sessionId/modes': typeof SessionsSessionIdModesRoute
  '/sessions/$sessionId/review': typeof SessionsSessionIdReviewRouteWithChildren
  '/sessions/$sessionId/share': typeof SessionsSessionIdShareRoute
  '/sync/conflicts/$taskId': typeof SyncConflictsTaskIdRoute
  '/sessions/$sessionId/capture/barcode': typeof SessionsSessionIdCaptureBarcodeRoute
  '/sessions/$sessionId/capture/gps': typeof SessionsSessionIdCaptureGpsRoute
  '/sessions/$sessionId/capture/note': typeof SessionsSessionIdCaptureNoteRoute
  '/sessions/$sessionId/capture/photo': typeof SessionsSessionIdCapturePhotoRouteWithChildren
  '/sessions/$sessionId/capture/video': typeof SessionsSessionIdCaptureVideoRoute
  '/sessions/$sessionId/capture/voice': typeof SessionsSessionIdCaptureVoiceRouteWithChildren
  '/sessions/$sessionId/captures/$captureId': typeof SessionsSessionIdCapturesCaptureIdRoute
  '/sessions/$sessionId/form/$fieldId': typeof SessionsSessionIdFormFieldIdRouteWithChildren
  '/sessions/$sessionId/review/sign': typeof SessionsSessionIdReviewSignRoute
  '/sessions/$sessionId/review/success': typeof SessionsSessionIdReviewSuccessRoute
  '/sessions/$sessionId/form/$fieldId/suggestions': typeof SessionsSessionIdFormFieldIdSuggestionsRoute
  '/sessions/$sessionId/capture/photo/review/$captureId': typeof SessionsSessionIdCapturePhotoReviewCaptureIdRoute
  '/sessions/$sessionId/capture/voice/review/$captureId': typeof SessionsSessionIdCaptureVoiceReviewCaptureIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/design-showcase': typeof DesignShowcaseRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/projects': typeof ProjectsRoute
  '/share': typeof ShareRoute
  '/submissions': typeof SubmissionsRoute
  '/templates': typeof TemplatesRoute
  '/welcome': typeof WelcomeRoute
  '/onboarding/permissions': typeof OnboardingPermissionsRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRouteWithChildren
  '/sessions/new': typeof SessionsNewRoute
  '/sync/active': typeof SyncActiveRoute
  '/sync/': typeof SyncIndexRoute
  '/sessions/$sessionId/form': typeof SessionsSessionIdFormRouteWithChildren
  '/sessions/$sessionId/modes': typeof SessionsSessionIdModesRoute
  '/sessions/$sessionId/review': typeof SessionsSessionIdReviewRouteWithChildren
  '/sessions/$sessionId/share': typeof SessionsSessionIdShareRoute
  '/sync/conflicts/$taskId': typeof SyncConflictsTaskIdRoute
  '/sessions/$sessionId/capture/barcode': typeof SessionsSessionIdCaptureBarcodeRoute
  '/sessions/$sessionId/capture/gps': typeof SessionsSessionIdCaptureGpsRoute
  '/sessions/$sessionId/capture/note': typeof SessionsSessionIdCaptureNoteRoute
  '/sessions/$sessionId/capture/photo': typeof SessionsSessionIdCapturePhotoRouteWithChildren
  '/sessions/$sessionId/capture/video': typeof SessionsSessionIdCaptureVideoRoute
  '/sessions/$sessionId/capture/voice': typeof SessionsSessionIdCaptureVoiceRouteWithChildren
  '/sessions/$sessionId/captures/$captureId': typeof SessionsSessionIdCapturesCaptureIdRoute
  '/sessions/$sessionId/form/$fieldId': typeof SessionsSessionIdFormFieldIdRouteWithChildren
  '/sessions/$sessionId/review/sign': typeof SessionsSessionIdReviewSignRoute
  '/sessions/$sessionId/review/success': typeof SessionsSessionIdReviewSuccessRoute
  '/sessions/$sessionId/form/$fieldId/suggestions': typeof SessionsSessionIdFormFieldIdSuggestionsRoute
  '/sessions/$sessionId/capture/photo/review/$captureId': typeof SessionsSessionIdCapturePhotoReviewCaptureIdRoute
  '/sessions/$sessionId/capture/voice/review/$captureId': typeof SessionsSessionIdCaptureVoiceReviewCaptureIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/design-showcase'
    | '/inbox'
    | '/login'
    | '/projects'
    | '/share'
    | '/submissions'
    | '/templates'
    | '/welcome'
    | '/onboarding/permissions'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/sync/active'
    | '/sync/'
    | '/sessions/$sessionId/form'
    | '/sessions/$sessionId/modes'
    | '/sessions/$sessionId/review'
    | '/sessions/$sessionId/share'
    | '/sync/conflicts/$taskId'
    | '/sessions/$sessionId/capture/barcode'
    | '/sessions/$sessionId/capture/gps'
    | '/sessions/$sessionId/capture/note'
    | '/sessions/$sessionId/capture/photo'
    | '/sessions/$sessionId/capture/video'
    | '/sessions/$sessionId/capture/voice'
    | '/sessions/$sessionId/captures/$captureId'
    | '/sessions/$sessionId/form/$fieldId'
    | '/sessions/$sessionId/review/sign'
    | '/sessions/$sessionId/review/success'
    | '/sessions/$sessionId/form/$fieldId/suggestions'
    | '/sessions/$sessionId/capture/photo/review/$captureId'
    | '/sessions/$sessionId/capture/voice/review/$captureId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/design-showcase'
    | '/inbox'
    | '/login'
    | '/projects'
    | '/share'
    | '/submissions'
    | '/templates'
    | '/welcome'
    | '/onboarding/permissions'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/sync/active'
    | '/sync'
    | '/sessions/$sessionId/form'
    | '/sessions/$sessionId/modes'
    | '/sessions/$sessionId/review'
    | '/sessions/$sessionId/share'
    | '/sync/conflicts/$taskId'
    | '/sessions/$sessionId/capture/barcode'
    | '/sessions/$sessionId/capture/gps'
    | '/sessions/$sessionId/capture/note'
    | '/sessions/$sessionId/capture/photo'
    | '/sessions/$sessionId/capture/video'
    | '/sessions/$sessionId/capture/voice'
    | '/sessions/$sessionId/captures/$captureId'
    | '/sessions/$sessionId/form/$fieldId'
    | '/sessions/$sessionId/review/sign'
    | '/sessions/$sessionId/review/success'
    | '/sessions/$sessionId/form/$fieldId/suggestions'
    | '/sessions/$sessionId/capture/photo/review/$captureId'
    | '/sessions/$sessionId/capture/voice/review/$captureId'
  id:
    | '__root__'
    | '/'
    | '/design-showcase'
    | '/inbox'
    | '/login'
    | '/projects'
    | '/share'
    | '/submissions'
    | '/templates'
    | '/welcome'
    | '/onboarding/permissions'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/sync/active'
    | '/sync/'
    | '/sessions/$sessionId/form'
    | '/sessions/$sessionId/modes'
    | '/sessions/$sessionId/review'
    | '/sessions/$sessionId/share'
    | '/sync/conflicts/$taskId'
    | '/sessions/$sessionId/capture/barcode'
    | '/sessions/$sessionId/capture/gps'
    | '/sessions/$sessionId/capture/note'
    | '/sessions/$sessionId/capture/photo'
    | '/sessions/$sessionId/capture/video'
    | '/sessions/$sessionId/capture/voice'
    | '/sessions/$sessionId/captures/$captureId'
    | '/sessions/$sessionId/form/$fieldId'
    | '/sessions/$sessionId/review/sign'
    | '/sessions/$sessionId/review/success'
    | '/sessions/$sessionId/form/$fieldId/suggestions'
    | '/sessions/$sessionId/capture/photo/review/$captureId'
    | '/sessions/$sessionId/capture/voice/review/$captureId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DesignShowcaseRoute: typeof DesignShowcaseRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  ProjectsRoute: typeof ProjectsRoute
  ShareRoute: typeof ShareRoute
  SubmissionsRoute: typeof SubmissionsRoute
  TemplatesRoute: typeof TemplatesRoute
  WelcomeRoute: typeof WelcomeRoute
  OnboardingPermissionsRoute: typeof OnboardingPermissionsRoute
  SessionsSessionIdRoute: typeof SessionsSessionIdRouteWithChildren
  SessionsNewRoute: typeof SessionsNewRoute
  SyncActiveRoute: typeof SyncActiveRoute
  SyncIndexRoute: typeof SyncIndexRoute
  SyncConflictsTaskIdRoute: typeof SyncConflictsTaskIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submissions': {
      id: '/submissions'
      path: '/submissions'
      fullPath: '/submissions'
      preLoaderRoute: typeof SubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share': {
      id: '/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-showcase': {
      id: '/design-showcase'
      path: '/design-showcase'
      fullPath: '/design-showcase'
      preLoaderRoute: typeof DesignShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync/': {
      id: '/sync/'
      path: '/sync'
      fullPath: '/sync/'
      preLoaderRoute: typeof SyncIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync/active': {
      id: '/sync/active'
      path: '/sync/active'
      fullPath: '/sync/active'
      preLoaderRoute: typeof SyncActiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/new': {
      id: '/sessions/new'
      path: '/sessions/new'
      fullPath: '/sessions/new'
      preLoaderRoute: typeof SessionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$sessionId': {
      id: '/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof SessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/permissions': {
      id: '/onboarding/permissions'
      path: '/onboarding/permissions'
      fullPath: '/onboarding/permissions'
      preLoaderRoute: typeof OnboardingPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync/conflicts/$taskId': {
      id: '/sync/conflicts/$taskId'
      path: '/sync/conflicts/$taskId'
      fullPath: '/sync/conflicts/$taskId'
      preLoaderRoute: typeof SyncConflictsTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$sessionId/share': {
      id: '/sessions/$sessionId/share'
      path: '/share'
      fullPath: '/sessions/$sessionId/share'
      preLoaderRoute: typeof SessionsSessionIdShareRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/review': {
      id: '/sessions/$sessionId/review'
      path: '/review'
      fullPath: '/sessions/$sessionId/review'
      preLoaderRoute: typeof SessionsSessionIdReviewRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/modes': {
      id: '/sessions/$sessionId/modes'
      path: '/modes'
      fullPath: '/sessions/$sessionId/modes'
      preLoaderRoute: typeof SessionsSessionIdModesRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/form': {
      id: '/sessions/$sessionId/form'
      path: '/form'
      fullPath: '/sessions/$sessionId/form'
      preLoaderRoute: typeof SessionsSessionIdFormRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/review/success': {
      id: '/sessions/$sessionId/review/success'
      path: '/success'
      fullPath: '/sessions/$sessionId/review/success'
      preLoaderRoute: typeof SessionsSessionIdReviewSuccessRouteImport
      parentRoute: typeof SessionsSessionIdReviewRoute
    }
    '/sessions/$sessionId/review/sign': {
      id: '/sessions/$sessionId/review/sign'
      path: '/sign'
      fullPath: '/sessions/$sessionId/review/sign'
      preLoaderRoute: typeof SessionsSessionIdReviewSignRouteImport
      parentRoute: typeof SessionsSessionIdReviewRoute
    }
    '/sessions/$sessionId/form/$fieldId': {
      id: '/sessions/$sessionId/form/$fieldId'
      path: '/$fieldId'
      fullPath: '/sessions/$sessionId/form/$fieldId'
      preLoaderRoute: typeof SessionsSessionIdFormFieldIdRouteImport
      parentRoute: typeof SessionsSessionIdFormRoute
    }
    '/sessions/$sessionId/captures/$captureId': {
      id: '/sessions/$sessionId/captures/$captureId'
      path: '/captures/$captureId'
      fullPath: '/sessions/$sessionId/captures/$captureId'
      preLoaderRoute: typeof SessionsSessionIdCapturesCaptureIdRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/voice': {
      id: '/sessions/$sessionId/capture/voice'
      path: '/capture/voice'
      fullPath: '/sessions/$sessionId/capture/voice'
      preLoaderRoute: typeof SessionsSessionIdCaptureVoiceRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/video': {
      id: '/sessions/$sessionId/capture/video'
      path: '/capture/video'
      fullPath: '/sessions/$sessionId/capture/video'
      preLoaderRoute: typeof SessionsSessionIdCaptureVideoRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/photo': {
      id: '/sessions/$sessionId/capture/photo'
      path: '/capture/photo'
      fullPath: '/sessions/$sessionId/capture/photo'
      preLoaderRoute: typeof SessionsSessionIdCapturePhotoRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/note': {
      id: '/sessions/$sessionId/capture/note'
      path: '/capture/note'
      fullPath: '/sessions/$sessionId/capture/note'
      preLoaderRoute: typeof SessionsSessionIdCaptureNoteRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/gps': {
      id: '/sessions/$sessionId/capture/gps'
      path: '/capture/gps'
      fullPath: '/sessions/$sessionId/capture/gps'
      preLoaderRoute: typeof SessionsSessionIdCaptureGpsRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/capture/barcode': {
      id: '/sessions/$sessionId/capture/barcode'
      path: '/capture/barcode'
      fullPath: '/sessions/$sessionId/capture/barcode'
      preLoaderRoute: typeof SessionsSessionIdCaptureBarcodeRouteImport
      parentRoute: typeof SessionsSessionIdRoute
    }
    '/sessions/$sessionId/form/$fieldId/suggestions': {
      id: '/sessions/$sessionId/form/$fieldId/suggestions'
      path: '/suggestions'
      fullPath: '/sessions/$sessionId/form/$fieldId/suggestions'
      preLoaderRoute: typeof SessionsSessionIdFormFieldIdSuggestionsRouteImport
      parentRoute: typeof SessionsSessionIdFormFieldIdRoute
    }
    '/sessions/$sessionId/capture/voice/review/$captureId': {
      id: '/sessions/$sessionId/capture/voice/review/$captureId'
      path: '/review/$captureId'
      fullPath: '/sessions/$sessionId/capture/voice/review/$captureId'
      preLoaderRoute: typeof SessionsSessionIdCaptureVoiceReviewCaptureIdRouteImport
      parentRoute: typeof SessionsSessionIdCaptureVoiceRoute
    }
    '/sessions/$sessionId/capture/photo/review/$captureId': {
      id: '/sessions/$sessionId/capture/photo/review/$captureId'
      path: '/review/$captureId'
      fullPath: '/sessions/$sessionId/capture/photo/review/$captureId'
      preLoaderRoute: typeof SessionsSessionIdCapturePhotoReviewCaptureIdRouteImport
      parentRoute: typeof SessionsSessionIdCapturePhotoRoute
    }
  }
}

interface SessionsSessionIdFormFieldIdRouteChildren {
  SessionsSessionIdFormFieldIdSuggestionsRoute: typeof SessionsSessionIdFormFieldIdSuggestionsRoute
}

const SessionsSessionIdFormFieldIdRouteChildren: SessionsSessionIdFormFieldIdRouteChildren =
  {
    SessionsSessionIdFormFieldIdSuggestionsRoute:
      SessionsSessionIdFormFieldIdSuggestionsRoute,
  }

const SessionsSessionIdFormFieldIdRouteWithChildren =
  SessionsSessionIdFormFieldIdRoute._addFileChildren(
    SessionsSessionIdFormFieldIdRouteChildren,
  )

interface SessionsSessionIdFormRouteChildren {
  SessionsSessionIdFormFieldIdRoute: typeof SessionsSessionIdFormFieldIdRouteWithChildren
}

const SessionsSessionIdFormRouteChildren: SessionsSessionIdFormRouteChildren = {
  SessionsSessionIdFormFieldIdRoute:
    SessionsSessionIdFormFieldIdRouteWithChildren,
}

const SessionsSessionIdFormRouteWithChildren =
  SessionsSessionIdFormRoute._addFileChildren(
    SessionsSessionIdFormRouteChildren,
  )

interface SessionsSessionIdReviewRouteChildren {
  SessionsSessionIdReviewSignRoute: typeof SessionsSessionIdReviewSignRoute
  SessionsSessionIdReviewSuccessRoute: typeof SessionsSessionIdReviewSuccessRoute
}

const SessionsSessionIdReviewRouteChildren: SessionsSessionIdReviewRouteChildren =
  {
    SessionsSessionIdReviewSignRoute: SessionsSessionIdReviewSignRoute,
    SessionsSessionIdReviewSuccessRoute: SessionsSessionIdReviewSuccessRoute,
  }

const SessionsSessionIdReviewRouteWithChildren =
  SessionsSessionIdReviewRoute._addFileChildren(
    SessionsSessionIdReviewRouteChildren,
  )

interface SessionsSessionIdCapturePhotoRouteChildren {
  SessionsSessionIdCapturePhotoReviewCaptureIdRoute: typeof SessionsSessionIdCapturePhotoReviewCaptureIdRoute
}

const SessionsSessionIdCapturePhotoRouteChildren: SessionsSessionIdCapturePhotoRouteChildren =
  {
    SessionsSessionIdCapturePhotoReviewCaptureIdRoute:
      SessionsSessionIdCapturePhotoReviewCaptureIdRoute,
  }

const SessionsSessionIdCapturePhotoRouteWithChildren =
  SessionsSessionIdCapturePhotoRoute._addFileChildren(
    SessionsSessionIdCapturePhotoRouteChildren,
  )

interface SessionsSessionIdCaptureVoiceRouteChildren {
  SessionsSessionIdCaptureVoiceReviewCaptureIdRoute: typeof SessionsSessionIdCaptureVoiceReviewCaptureIdRoute
}

const SessionsSessionIdCaptureVoiceRouteChildren: SessionsSessionIdCaptureVoiceRouteChildren =
  {
    SessionsSessionIdCaptureVoiceReviewCaptureIdRoute:
      SessionsSessionIdCaptureVoiceReviewCaptureIdRoute,
  }

const SessionsSessionIdCaptureVoiceRouteWithChildren =
  SessionsSessionIdCaptureVoiceRoute._addFileChildren(
    SessionsSessionIdCaptureVoiceRouteChildren,
  )

interface SessionsSessionIdRouteChildren {
  SessionsSessionIdFormRoute: typeof SessionsSessionIdFormRouteWithChildren
  SessionsSessionIdModesRoute: typeof SessionsSessionIdModesRoute
  SessionsSessionIdReviewRoute: typeof SessionsSessionIdReviewRouteWithChildren
  SessionsSessionIdShareRoute: typeof SessionsSessionIdShareRoute
  SessionsSessionIdCaptureBarcodeRoute: typeof SessionsSessionIdCaptureBarcodeRoute
  SessionsSessionIdCaptureGpsRoute: typeof SessionsSessionIdCaptureGpsRoute
  SessionsSessionIdCaptureNoteRoute: typeof SessionsSessionIdCaptureNoteRoute
  SessionsSessionIdCapturePhotoRoute: typeof SessionsSessionIdCapturePhotoRouteWithChildren
  SessionsSessionIdCaptureVideoRoute: typeof SessionsSessionIdCaptureVideoRoute
  SessionsSessionIdCaptureVoiceRoute: typeof SessionsSessionIdCaptureVoiceRouteWithChildren
  SessionsSessionIdCapturesCaptureIdRoute: typeof SessionsSessionIdCapturesCaptureIdRoute
}

const SessionsSessionIdRouteChildren: SessionsSessionIdRouteChildren = {
  SessionsSessionIdFormRoute: SessionsSessionIdFormRouteWithChildren,
  SessionsSessionIdModesRoute: SessionsSessionIdModesRoute,
  SessionsSessionIdReviewRoute: SessionsSessionIdReviewRouteWithChildren,
  SessionsSessionIdShareRoute: SessionsSessionIdShareRoute,
  SessionsSessionIdCaptureBarcodeRoute: SessionsSessionIdCaptureBarcodeRoute,
  SessionsSessionIdCaptureGpsRoute: SessionsSessionIdCaptureGpsRoute,
  SessionsSessionIdCaptureNoteRoute: SessionsSessionIdCaptureNoteRoute,
  SessionsSessionIdCapturePhotoRoute:
    SessionsSessionIdCapturePhotoRouteWithChildren,
  SessionsSessionIdCaptureVideoRoute: SessionsSessionIdCaptureVideoRoute,
  SessionsSessionIdCaptureVoiceRoute:
    SessionsSessionIdCaptureVoiceRouteWithChildren,
  SessionsSessionIdCapturesCaptureIdRoute:
    SessionsSessionIdCapturesCaptureIdRoute,
}

const SessionsSessionIdRouteWithChildren =
  SessionsSessionIdRoute._addFileChildren(SessionsSessionIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DesignShowcaseRoute: DesignShowcaseRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  ProjectsRoute: ProjectsRoute,
  ShareRoute: ShareRoute,
  SubmissionsRoute: SubmissionsRoute,
  TemplatesRoute: TemplatesRoute,
  WelcomeRoute: WelcomeRoute,
  OnboardingPermissionsRoute: OnboardingPermissionsRoute,
  SessionsSessionIdRoute: SessionsSessionIdRouteWithChildren,
  SessionsNewRoute: SessionsNewRoute,
  SyncActiveRoute: SyncActiveRoute,
  SyncIndexRoute: SyncIndexRoute,
  SyncConflictsTaskIdRoute: SyncConflictsTaskIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
